import { render, staticRenderFns } from "./AlertsTable.vue?vue&type=template&id=b7401934&scoped=true&"
import script from "./AlertsTable.vue?vue&type=script&lang=ts&"
export * from "./AlertsTable.vue?vue&type=script&lang=ts&"
import style0 from "./AlertsTable.vue?vue&type=style&index=0&id=b7401934&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.10.1_css-loader@6.7.3_vue-template-compiler@2.7.15_webpack@5.80.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7401934",
  null
  
)

export default component.exports